import React from 'react';
import clsx from 'clsx';
import { useParams } from 'react-router-dom';
import Header from 'components/shared/header/component';
import PlayerAllocating from 'components/shared/playerAllocating/component';
export default function ViewOnboardingPlayersNew() {
    var companyId = useParams().companyId;
    return (React.createElement("div", { className: clsx(['wrapper wrapper--no-sidebar']) },
        React.createElement("div", { className: "container-fluid" },
            React.createElement(Header, null),
            React.createElement("div", { className: clsx(['playerdashboard']) },
                React.createElement(PlayerAllocating, { companyId: companyId || null })))));
}
